import { ApplicationToggle } from './model/application-toggle';
export class FeatureToggleService {
  private toggleMap: Map<string, ApplicationToggle> = new Map();

  constructor(readonly featureToggles: ApplicationToggle[] = []) {
    if (featureToggles) {
      featureToggles.forEach((toggle: ApplicationToggle) => {
        this.toggleMap.set(toggle.name, toggle);
      });
    }
    // Get toggles config from local storage for testing
    const localToggles: Map<string, boolean> = new Map(JSON.parse(localStorage.getItem('toggles')));
    if (localToggles) {
      localToggles.forEach((isEnabled: boolean, toggleName: string) => {
        if (this.toggleMap.has(toggleName)) {
          this.toggleMap.get(toggleName).enabled = isEnabled;
        }
      });
    }
  }

  public isEnabled(feature: string): boolean {
    return this.toggleMap.has(feature) && this.toggleMap.get(feature).enabled;
  }
}